export const FLAGS = {
  ENG_264_EXCLUSIONS: {
    key: "eng264Exclusions",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_727_DISCORD_QR: {
    key: "eng727DiscordQr",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_844_CONTEXT_SEARCH_TAB: {
    key: "eng844ContextSearchTab",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_846_UI_SEARCH_LAG: {
    key: "eng846DrawerUiLag",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_998_ROWS_PER_PAGE: {
    key: "eng998RowsPerPage",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_1015_DEFAULT_DATE: {
    key: "eng1015DefaultDate",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_1109_OTHER_QUERY_TYPES: {
    key: "eng1109OtherQueryTypes",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_1121_CACHE_RESULTS_COUNT: {
    key: "eng1121CacheResults",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_1181_DELETE_SCRAPER: {
    key: "eng1181DeleteScraper",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_1186_SCROLL_TO_BOTTOM: {
    key: "eng1186ScrollToBottom",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_1194_REMOUNTING_CONTEXT: {
    key: "eng1194RemountingContext",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_1195_SPEED_TIMER: {
    key: "eng1195SpeedTimer",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_1241_CASE_INSENSITIVE_PARAMS: {
    key: "eng1241CaseInsensitiveParams",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_1196_ATTACHMENT_DOWNLOADS: {
    key: "eng1196AttachmentDownloads",
    defaultValue: false,
    type: "boolean" as const,
  },
  ENG_1389_ADD_DISCORD_SCRAPER_FIX: {
    key: "eng1389AddDiscordScraperFix",
    defaultValue: false,
    type: "boolean" as const,
  },
} as const;

export type FlagId = keyof typeof FLAGS;
